import { Box, TextField, Button, Slider, Tooltip, IconButton, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import PopupForm from "../../Components/PopupForm";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import CustomeSelectField from "../../Components/CustomeSelectField";
import CustomTextField from "../../Components/CustomTextField";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import host from "../../assets/js/Host";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ContainerOfInputFields } from "../../Components/ThemDesign";
import { debounce } from "debounce";
import axios from "../../assets/js/AxiosInterceptors";
import helpers from "../../assets/js/helper";
import CachedIcon from '@mui/icons-material/Cached';
import AddIcon from "@mui/icons-material/Add";
import VehiclesList from "../UnitsTransfer/components/VehiclesList";
import { setGlobalLoading } from "../../reduxStore/SettingsReducer";

const cookies = new Cookies();

const RenderContent = (props) => {
  const [t] = useTranslation("common");
  const maintheme = useSelector((state) => state.themeData.maintheme);
  return (
    <Box className="Container-fluid">
      <Box className="row pt-4">
        <Box className="col-12 col-sm-12 col-md-12 m-auto d-flex flex-column justify-content-center align-items-center">
          <Box
            style={{
              display:'flex',
              alignItems:'center',
              width:'100%',
              justifyContent:'space-between'
            }}
          >
            <CustomeSelectField
              label={"Customer Name"}
              haswidth={true}
              customWidth={'90%'}
              value={props?.selectedCustomer ? props?.selectedCustomer : null}
              list={props?.customers ? props?.customers : []}
              // customGetOptionLabel={(option) => option?.label}
              customGetOptionLabel={(option) => option?.name}
              error={false}
              message={[]}
              multiple={false}
              readOnly={false}
              focused={true}
              onChange={(e, newValue) => {
                props?.setSelectedCustomer(newValue);
              }}
              onSearch={(value) => {
                if (value?.target.value)
                  props?.handleCustomerSearch(value?.target.value);
              }}
              onClearClick={() => {
                props?.setSelectedCustomer([]);
              }}
            />
            <Tooltip arrow title={"Sync Customers with ERP"}>
              <IconButton
                onClick={async () => {
                  let response = await helpers.handleSyncCustomers()
                  if (response) {
                    props?.loadDataOfCustomers()
                  }
                }}
                sx={{
                  // width:'15%',
                  backgroundColor: "#fff",
                  boxShadow: "0 0 7px -2px rgba(0,0,0,0.4)",
                  width:'50px',
                  height:'50px'
                }}
              >
                <CachedIcon sx={{ color: "#000" }} />
              </IconButton>
            </Tooltip>
          </Box>
          <Box sx={{ marginTop: "10px" }}></Box>
          <CustomTextField
            label={"Description"}
            haswidth={true}
            value={props?.description}
            error={false}
            hasMultipleLine={true}
            message={""}
            readOnly={false}
            onChange={(e) => {
              props?.setDescription(e.target.value);
            }}
            onClearClick={() => {
              props?.setDescription("");
            }}
          />
          <Box sx={{ marginTop: "10px" }}></Box>
          <CustomeSelectField
            label={"Task Monitor"}
            haswidth={true}
            value={props?.selectedUser}
            list={props?.users ? props?.users : []}
            customGetOptionLabel={(option) => option?.name}
            error={false}
            message={[]}
            multiple={false}
            readOnly={false}
            focused={true}
            onChange={(e, newValue) => {
              props?.setSelectedUser(newValue);
            }}
            onClearClick={() => {
              props?.setSelectedUser(null);
            }}
          />
          <Box sx={{ marginTop: "10px" }}></Box>
          <Box
            sx={{
              backgroundColor: "#fff",
              boxShadow: "0 0 7px -2px rgba(0,0,0,0.4)",
              borderRadius: "2px",
              width: "97%",
              padding: "5px 12px",
              borderLeft: "5px solid #1e6a99",
            }}
          >
            <span style={{ fontWeight: "Bold" }}>Task Weight</span>
            <Slider
              style={{ width: "100%" }}
              defaultValue={props.weight}
              value={props?.weight}
              onChange={props?.handleChangeweight}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={10}
            />
          </Box>

          <ContainerOfInputFields
            mainTheme={maintheme}
            customeWidth={"100%"}
            hasError={false}
            haswidth={true}
          >
            <Box
              sx={{
                position: "relative",
                // margin: "5px 0",
                width: "100%",
                backgroundColor: "#fff",
              }}
              className="mt-3 orderdata"
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  label={"Deadline Date"}
                  inputFormat="MM/DD/YYYY HH:mm:ss"
                  value={props?.startDate}
                  // minDate={new Date()}
                  inputProps={{
                    placeholder: "لم يتم التحديد",
                  }}
                  maxDate={new Date()}
                  onChange={(date) => props?.handleChange(date)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="filled"
                      focused={true}
                      inputProps={{
                        ...params.inputProps,
                        placeholder: "لم يتم التحديد",
                      }}
                    />
                  )}
                />
                {props?.startDate ? (
                  <CloseIcon
                    className="closeIcon"
                    onClick={() => props?.handleChange(null)}
                    sx={{
                      right: "37px !important",
                      top: "14px !important",
                    }}
                  />
                ) : null}
              </LocalizationProvider>
            </Box>
          </ContainerOfInputFields>
          <Box sx={{ marginTop: "10px" }}></Box>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              paddingRight: "10px"
            }}
          >
            <CustomTextField
              label={"رقم الوحدة"}
              haswidth={true}
              customWidth="100%"
              value={props?.vehicleNumber}
              error={false}
              hasMultipleLine={true}
              message={""}
              readOnly={false}
              onChange={(e) => {
                props?.setVehicleNumber(e.target.value);
              }}
              onClearClick={() => {
                props?.setVehicleNumber("");
              }}
            />
            <Button
              variant="contained"
              className="iconeFilterSearch"
              sx={{
                borderRadius: 1,
                width: "90px !important",
                minWidth: "80px !important",
                maxWidth: "80px !important",
                height: "55px",
                fontFamily: "Cairo-Bold",
                padding: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 0.3,
              }}
              onClick={props?.addDetails}
            >
              <Typography sx={{ fontSize: "13px", mt: "2.5px" }}>
                ADD
              </Typography>
              <AddIcon />
            </Button>
          </Box>
          <Box sx={{ marginTop: "10px" }}></Box>
          <Box
            sx={{
              width: "97%",
              display: "flex",
              alignItems: "center"
            }}
          >
            <VehiclesList
              list={props?.selectedVehicles}
              deleteVehicle={props?.deleteVehicle}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const RenderFooter = (props) => {
  const gridtheme = useSelector((state) => state.themeData.gridtheme);
  const [t] = useTranslation("common");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box display="flex">
          <Button
            variant="outlined"
            // spacing={2}
            sx={{
              width: "50% !important",
              // flexGrow: 1,
              minWidth: "80px !important",
              maxWidth: "80px !important",
              margin: 1,
              backgroundColor: "#f7f7f7",
              borderColor: gridtheme?.colorWhite,
              color: gridtheme?.colorblack,
              boxShadow: "0 0 7px -2px white",
              //   color:SearchButtonTheme?.clear_button_text_color,
              "&:hover": {
                backgroundColor: "#f7f7f7",
                borderColor: gridtheme?.colorWhite,
                color: gridtheme?.colorblack,
                boxShadow: "0 0 7px 1px white",
                boxShadow: "0",
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterClear"
            color="secondary"
            onClick={() => {
              props.setOpen(false);
            }}
          >
            {"Close"}
          </Button>
          <Button
            variant="contained"
            // spacing={2}
            sx={{
              // flexGrow: 1,
              margin: 1,
              width: "80px !important",
              minWidth: "80px !important",
              maxWidth: "80px !important",
              "&:hover": {
                //   backgroundColor:SearchButtonTheme?.search_button_color+'88',
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterSearch"
            onClick={() => {
              props.submit();
            }}
          >
            {"Save"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default function EditCustomer(props) {
  const headers = {
    jwt: cookies.get("token")
  }
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState([]);
  const [customer, setCustomer] = useState("");
  const [user, setUser] = useState("");
  const [users, setUsers] = useState([]);
  const [description, setDescription] = useState("");
  const [deadTime, setDeadTime] = useState("");
  const [statusId, setStatusId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [typeId, setTypeId] = useState("");
  const [moniter, setMoniter] = useState([]);
  const [geoName, setGeoName] = useState("");
  const [dimentions, setDimentions] = useState([]);
  const [weight, setWeight] = useState("");
  const [isShown, setIsShown] = useState(false);
  const [spin, setSpin] = useState(false);
  const [taskType1, setTaskType1] = useState("");
  const [selected, setSelected] = useState([props?.customer?.id]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [label, setLabel] = useState(props?.customer?.name);
  const [selectedMonitor, setSelectedMonitor] = useState([props?.monitor?.id]);
  const [labelMonitor, setLabelMonitor] = useState(props?.monitor?.name);
  const [type, setType] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [allTaskUnits, setAllTaskUnits] = useState([]);
  const [customersUnits, setCustomersUnits] = useState([]);
  const [selectedFinanceWorkType, setSelectedFinanceWorkType] = useState(null);

  useEffect(() => {
    if (props?.taskData && props?.taskData?.task_units_transfer) {
      setSelectedVehicles(props?.taskData?.task_units_transfer);
    }
  }, [props?.taskData?.task_units_transfer]);
  
  const deleteVehicle = (idToDelete) => {
    setSelectedVehicles((prevState) => {
      const updatedVehicles = prevState.filter((veh) => veh.id !== idToDelete);
      return updatedVehicles;
    });
  };
  
  const addDetails = () => {
    if (
      selectedCustomer?.erp_server_type
        ? JSON.parse(selectedCustomer?.erp_server_type) === 1
        : null
    ) {
      var items = [];
      var wantedUnits = [];
      var notFound = [];
      var searchKey = "";
      vehicleNumber?.split(/\n/)?.forEach((v) => {
        if (v.trim()?.length) {
          items.push(v.trim());
        }
      });
      // setSearchKeys(items);
      if (customersUnits.some((cu) => items[0] === cu?.name)) {
        searchKey = "name";
        if (items?.length && customersUnits?.length) {
          items.map((item) => {
            const foundUnit = customersUnits.find(
              (unit) =>
                item?.length &&
                unit?.name?.includes(item) &&
                !allTaskUnits?.some((atu) => atu?.id === unit?.id)
            );
            if (foundUnit) {
              wantedUnits.push(foundUnit);
              setAllTaskUnits([...allTaskUnits, foundUnit]);
            } else {
              notFound.push(item);
            }
          });
        }
      } else if (customersUnits.some((cu) => items[0] === cu?.imei)) {
        searchKey = "imei";
        if (items?.length && customersUnits?.length) {
          items.map((item) => {
            const foundUnit = customersUnits.find(
              (unit) => unit?.imei === item
            );
            if (foundUnit) {
              wantedUnits.push(foundUnit);
            } else {
              notFound.push(item);
            }
          });
        }
      } else {
        toast.warning(
          'لم يتم العثور على الوحدات التالية "' + items.join(", ") + '"'
        );
      }
      if (wantedUnits?.length) {
        if (wantedUnits?.length && selectedVehicles?.length) {
          wantedUnits?.map((veh1) => {
            if (!selectedVehicles?.some((veh2) => veh1?.imei === veh2.imei)) {
              setSelectedVehicles([...selectedVehicles, veh1]);
            } else {
              toast.warning("الوحدة موجودة بالفعل: " + veh1?.name);
            }
          });
          setVehicleNumber("");
        } else {
          setSelectedVehicles([...selectedVehicles, ...wantedUnits]);
          setVehicleNumber("");
        }
      }
      if (notFound?.length) {
        toast.warning(
          'لم يتم العثور على الوحدات التالية "' + notFound.join(", ") + '"'
        );
      }
    }
  };
  
  const getVehicles = async () => {
    if (
      selectedCustomer &&
      selectedCustomer?.erp_server_id &&
      (selectedCustomer?.erp_server_type
        ? JSON.parse(selectedCustomer?.erp_server_type) === 1
        : null) &&
      typeof JSON.parse(selectedCustomer?.erp_wailon_acc_code) === "number"
    ) {
      try {
        dispatch(setGlobalLoading(true));
        await axios({
          url: host + "customers/get_customers_units",
          method: "GET",
          headers: headers,
          params: {
            erp_server_id: selectedCustomer?.erp_server_id
              ? selectedCustomer?.erp_server_id
              : props?.editTaskData?.customer?.erp_server_id,
            erp_wailon_acc_code: selectedCustomer?.erp_wailon_acc_code
              ? selectedCustomer?.erp_wailon_acc_code
              : props?.editTaskData?.customer?.erp_wailon_acc_code,
          },
        })
          .then((res) => {
            dispatch(setGlobalLoading(false));
            if (!res.data.status) {
              toast.error("Network Error!");
              setCustomersUnits([]);
            } else {
              if (res?.data?.data?.length) {
                setCustomersUnits(res?.data?.data);
              } else {
                setCustomersUnits([]);
                if (selectedFinanceWorkType?.id === 1) {
                  toast.info(
                    "لا يوجد وحدات مرتبطة بهذا الزبون في الوقت الحالي."
                  );
                }
              }
            }
          })
          .catch((e) => {
            dispatch(setGlobalLoading(false));
            console.log("Error", e);
          });
      } catch (error) {
        console.log("Error", error);
      }
    } else {
      setCustomersUnits([]);
      if (selectedFinanceWorkType?.id === 1) {
        toast.info("Customer Doesn't have a wialon account ID.");
      }
    }
  };

  const handleChange = (date) => {
    setStartDate(date);
  };
  
  const handleChangeweight = (event, newValue) => {
    setWeight(newValue);
  };

  useEffect(() => {
    console.log("customers data", props?.Allcustomer);
    if (props?.Allcustomer?.length > 0) {
      let arr = [];
      props?.Allcustomer?.length > 0 &&
        props?.Allcustomer?.map((itm) => {
          arr.push({
            ...itm,
            id: itm?.value,
          });
        });
      setCustomers(arr);
    }
  }, [props?.Allcustomer]);

  useEffect(() => {
    console.log("sdasdasdsadCustomer=>", props.customer);
    setSelectedCustomer(props.customer);
  }, [props.customer]);

  useEffect(() => {
    console.log("users data", props?.users);
    if (props?.users?.length > 0) {
      let arr = [];
      props?.users?.length > 0 &&
        props?.users?.map((itm) => {
          arr.push({
            name: itm?.label,
            id: itm?.value,
          });
        });
      setUsers(arr);
    }
  }, [props?.users]);

  useEffect(() => {
    console.log("sdasdasdsadMonitor=>", props?.monitor);
    setSelectedUser(props?.monitor);
  }, [props.monitor]);

  const submit = async () => {
    if (!selectedCustomer) {
      toast.error("Please, you must select a customer! ");
      return;
    }
    if (selectedCustomer && !selectedCustomer?.erp_cus_id) {
      toast.error("Please, you must replace this customer with a new customer from the list! ");
      return;
    }
    setLoading(true);
    var headers = {
      jwt: cookies.get("token"),
    };
    if (startDate !== "") {
      var milliseconds = new Date(startDate).getTime() + 3 * 60 * 60 * 1000; //add three hours
      var correctedDeadTime = new Date(milliseconds);
    }

    axios({
      url: host + `tasks/task/${props.id}`,
      method: "put",
      headers: headers,
      data: {
        customer_id: selectedCustomer && selectedCustomer?.id ? selectedCustomer?.id : selectedCustomer && selectedCustomer?.customer_id ? selectedCustomer?.customer_id : customerId,
        description: description ? description.replace(/['"]/g, "") : "",
        dead_time: correctedDeadTime,
        geo_name: geoName,
        geo_x: dimentions[0],
        geo_y: dimentions[1],
        weight: weight,
      },
    })
      .then((res) => {
        if (res.data.status === true) {
          //  if (moniter.length === undefined) {
          axios({
            url: host + `tasks/assign/monitor/${props.id}`,
            method: "PUT",
            headers: headers,
            data: {
              monitor_user_id: selectedUser ? selectedUser?.id : moniter,
            },
          }).then((res) => {
            const { onRefTask } = props.onRefTask;
            onRefTask();
          });
          axios({
            url: host + `tasks/units_transfer/${props.id}`,
            method: "PUT",
            headers: headers,
            data: {
              vehicles: selectedVehicles,
              remove_all: selectedVehicles?.length ? false : true
            },
          }).then((res) => {
            props?.setAddForm(false);
            dispatch(setGlobalLoading(false));
          });
          
          //  }
          setLoading(false);
          setSpin(false);
          props?.setAddForm(false);
          toast.success("task updated successfully");
          const { onRefTask } = props.onRefTask;
          onRefTask();
        } else if (res.data.status === false) {
          toast.error(res.data.data.message.text);
          setSpin(false);
          setLoading(false);
        }
      })
      .catch((err) => {
        toast.error("Network Error");
        setSpin(false);
        setLoading(false);
      });
  };

  const clearForm = () => { };

  useEffect(() => {
    // if (!props?.users) clearForm();
    if (props?.addForm) {
      let getIndex = props.allstatus.findIndex(
        (element) => element.label === props.status
      );
      let getIndex1 = props.type.findIndex(
        (element) => element.label === props.task_type
      );
      setStatusId(props.allstatus[getIndex]);
      setDescription(props.desc);
      setCustomer(props?.customer?.name);
      setCustomerId(props?.customer?.id);
      setMoniter(props?.moniter?.id);
      setType(props.type);
      setTaskType1(props.type[getIndex1]);
      setStartDate(
        props.time === "1970-01-01T00:00:00.000Z" ? "" : new Date(props.time)
      );
      setWeight(props?.weight);
      loadDataOfCustomers()
    }
  }, [props?.addForm]);
  const loadDataOfCustomers = async (searchParams) => {
    let data = null;
    let params = 'searchOperation="contains"&userData={}&';
    let paramsList = [];
    var headers = {
      jwt: cookies.get("token"),
    };
    try {
      if (searchParams && searchParams?.length > 0) {
        params +=
          'searchExpr="' +
          searchParams[0] +
          '"&searchValue="' +
          searchParams[1] +
          '"&';
      }
      params += 'is_add_or_update=1'
      data = await axios({
        url: host + `customers/page?${params}`,
        method: "get",
        headers: headers,
      })
        // return fetch(Host + `customers/page${params}`)
        .then((data) => {
          ////console.log(data.data)
          setCustomers(data.data?.data);
        });
    } catch (err) {
      console.log(err?.message);
    }
  };
  const handleCustomerSearch = debounce((value) => {
    let searchParams = ["customer_name", value];
    loadDataOfCustomers(searchParams);
  }, 500);
  
  useEffect(() => {
    getVehicles();
  }, [selectedCustomer]);

  return (
    <PopupForm
      open={props.addForm}
      setOpen={props.setAddForm}
      title={"Edit Task"}
      content={
        <RenderContent
          customers={customers}
          selectedCustomer={selectedCustomer}
          selected={selected}
          setSelected={setSelected}
          description={description}
          setDescription={setDescription}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          weight={weight}
          setWeight={setWeight}
          startDate={startDate}
          handleChange={handleChange}
          handleChangeweight={handleChangeweight}
          users={users}
          open={props.addForm}
          setOpen={props.setAddForm}
          handleCustomerSearch={handleCustomerSearch}
          setSelectedCustomer={setSelectedCustomer}
          loadDataOfCustomers={loadDataOfCustomers}
          selectedVehicles={selectedVehicles}
          deleteVehicle={deleteVehicle}
          addDetails={addDetails}
          setVehicleNumber={setVehicleNumber}
        />
      }
      footer={
        <RenderFooter
          open={props.addForm}
          setOpen={props.setAddForm}
          submit={submit}
        />
      }
    />
  );
}
